import { render, staticRenderFns } from "./EditDegradingPotentialForTax.vue?vue&type=template&id=401686f0&scoped=true&"
import script from "./EditDegradingPotentialForTax.vue?vue&type=script&lang=js&"
export * from "./EditDegradingPotentialForTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401686f0",
  null
  
)

export default component.exports